import React from 'react';

function ButtonBRK(props) {
  return (
    <button
      className={['button-accept', props.classes].join(' ')}
      onClick={props.onClick}
    >
      {props.name}
    </button>
  );
}

export default ButtonBRK;
